// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDzf7oeRs9PyL4jWbGrqFopYYItXmRPbkw",
  authDomain: "marazsir.firebaseapp.com",
  projectId: "marazsir",
  storageBucket: "marazsir.firebasestorage.app",
  messagingSenderId: "826356113345",
  appId: "1:826356113345:web:b497f8ed4ee971559a1940",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { app, auth, db, storage };
